export type Cursor = string;

export interface PagingLinks {
  next?: Cursor;
}
